import Button from "@material-ui/core/Button";

import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";

import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import logo from "assets/img/bi-gout.png";
import img from "assets/img/group-20.png";
import Panel from "components/Panel/Panel";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import appActions from "redux/actions/appActions";
import { CardWebinaire } from "./CardWebinaire";

const useStyles = makeStyles({
  grid: {
    height: "100vh",
    overflowY: "none"
  },
  img: {
    marginBottom: 16,
    marginTop: 16,
    marginLeft: 16,
    width: 35
  },
  infos: {
    fontSize: 20,
    letterSpacing: 0,
    fontFamily: "Work Sans",
    textAlign: "flex-start"
  },
  logo: {
    marginBottom: 16,
    marginTop: 16,
    marginLeft: 40
  },
  paragraphe: {
    fontFamily: "Work Sans",
    fontSize: 16,
    letterSpacing: 0,
    textAlign: "center",
    color: "#4a4a49"
  },
  span: {
    color: "#e85211"
  },
  validation: {
    color: "#4A4A49",
    fontFamily: "Work Sans",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: 0
  },
  check: {
    height: 32,
    color: "#5DD29D",
    alignItems: "center"
  },
  text: {
    color: "#FFFFFF",
    fontFamily: "Work Sans",
    display: "flex",
    alignItems: "center",
    textAlign: "center"
  },
  helpColor: {
    color: "#E85211",
    fontFamily: "Work Sans",
    fontSize: 32,
    fontWeight: 900,
    letterSpacing: 0,
    textAlign: "center"
  },
  help: {
    fontFamily: "Work Sans",
    fontSize: 32,
    fontWeight: 900,
    letterSpacing: 0,
    textAlign: "center"
  },
  back: {
    fontFamily: "Work Sans",
    fontSize: 14,
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    height: 42,
    borderRadius: 8,
    backgroundColor: "#6467CE",
    color: "#ffff",
    margin: "48px 0"
  },
  separator: {
    backgroundColor: "black",
    width: 700,
    height: 1,
    opacity: "17%",
    margin: "48px 0"
  }
});

/**
 * @type { {title: string, jour: string, horaire: string, link: string, recurrence?: string}[] }
 */
const webinaires = [
  {
    title: "LES IMPAYÉS",
    jour: "5 juin 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-les-impayes?s=820a8b4f-31b0-40e5-997e-b76f519737cf"
  },
  {
    title: "LA PROTECTION SOCIALE",
    jour: "12 juin 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-protection-sociale/live?s=4f8432dd-fd34-45e5-a2bc-2dfb40e9b482#/"
  },
  {
    title: "LES DIFFICULTÉS FINANCIÈRES",
    jour: "19 juin 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-prevenir-les-difficultes-financieres-ll-importance-de-se-faire-accompagner/live?s=be7ed7c4-be8a-46b1-876d-af07e6f5a357#/"
  },
  {
    title: "LES RESPONSABILITÉS CIVILES",
    jour: "26 juin 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-responsabilite-civile/live?s=9ed7578a-ed95-41c0-bd68-80b01dd7b137#/"
  },
  {
    title: "LES RISQUES DE L'ENTREPRISE",
    jour: "11 septembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/w/live?s=74d23f50-57b2-43f9-b9bd-cb1943aa04cf#/"
  },
  {
    title: "LA PROTECTION SOCIALE",
    jour: "18 septembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-protection-sociale/live?s=df91e4e3-ffe0-4ccf-978f-808a6606a06f#/"
  },
  {
    title: "LA PROTECTION JURIDIQUE",
    jour: "25 septembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-protection-juridique/live?s=68681c12-f080-4060-b3f2-541853fa1df6#/"
  },
  {
    title: "LES RESPONSABILITÉS CIVILES",
    jour: "2 octobre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-responsabilite-civile/live?s=ab9f1f99-e8fe-467e-b2ae-e8de2b9619d9#/"
  },
  {
    title: "COMMENT ÉVITER L'ÉPUISEMENT PROFESSIONNEL",
    jour: "9 octobre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-comment-eviter-lepuisement-professionnel/live?s=7b55ac61-362d-45e4-9193-f3971eb9bf4e#/"
  },
  {
    title: "LA RETRAITE",
    jour: "16 octobre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-comprendre-et-preparer-sa-retraite/live?s=d0e0aa3a-765b-462f-a512-c56d68b9f0dc#/"
  },
  {
    title: "LES RISQUES CYBER",
    jour: "6 novembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-les-risques-cyber/live?s=4b2857d5-252c-4893-bf31-9e550aaa712d#/"
  },
  {
    title: "LES IMPAYÉS",
    jour: "13 novembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-les-impayes/live?s=54d8cc53-33d2-471b-975d-c0b9c7b63b43#/"
  },
  {
    title: "LES RESPONSABILITÉS CIVILES",
    jour: "20 novembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-responsabilite-civile/live?s=4b5aceab-0c6c-4a84-b1b8-4a2d2d2ca28d#/"
  },
  {
    title: "PRÉVENIR LES DIFFICULTÉS FINANCIÈRES",
    jour: "27 novembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-prevenir-les-difficultes-financieres-ll-importance-de-se-faire-accompagner/live?s=c6d097e0-5af2-4eb4-86d8-6457cbc190cd#/"
  },
  {
    title: "LES RISQUES DE L'ENTREPRISE",
    jour: "4 décembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/w/live?s=92b053a0-bfb0-4ab8-9557-3ae382d8649c#/"
  },
  {
    title: "LA PROTECTION SOCIALE",
    jour: "11 décembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-protection-sociale/live?s=8adee60f-be32-491e-8c1f-75593911ad21#/"
  },
  {
    title: "LA DÉCENNALE",
    jour: "18 décembre 2025",
    horaire: "de 14h30 à 15h30",
    link:
      "https://app.livestorm.co/france-active/webinaire-edlc-la-garantie-decennale/live?s=39375e59-90b5-4867-9aa7-0d76333bba04#/"
  }
];

export default function SendMail(props) {
  const classes = useStyles();
  const formReducer = useSelector(store => store.formReducer);
  const create = useSelector(store => store.appReducer.prospect);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appActions.data_form(null, "jwt"));
  }, [dispatch]);

  return (
    <Grid className={classes.grid} container justify="flex-end">
      <Hidden only={"xs"}>
        <Grid item xs={12} sm={4} lg={4} xl={3}>
          <Panel step={5} history={props.history} />
        </Grid>
      </Hidden>
      {create.isLoading ? (
        <Grid
          container
          item
          xs={12}
          sm={8}
          lg={8}
          xl={9}
          justify="center"
          alignContent="center"
        >
          <CircularProgress style={{ color: "#E85313" }} size={50} />
        </Grid>
      ) : (
        <Grid container item xs={12} sm={8} lg={8} xl={9} justify="center">
          <Grid item xs={12} sm={9} className={classes.logo}>
            <img src={logo} alt="logo" />
          </Grid>

          <Grid container item xs={12} sm={12} justify="center">
            <img className={classes.img} src={img} alt="umbrella" />
          </Grid>

          <Grid item xs={12} sm={12}>
            <p className={classes.paragraphe}>
              <CheckCircleIcon
                style={{
                  color: "#5DD29D",
                  verticalAlign: "middle",
                  marginRight: 10,
                  fontSize: 35
                }}
              />
              <span className={classes.validation}>
                Votre demande a été prise en compte
              </span>
              <br />
              {formReducer?.tarif?.data?.length > 0 && (
                <p style={{ marginTop: 16 }}>
                  Vous allez recevoir votre devis dans les plus brefs délais par
                  mail à l’adresse{" "}
                  <span className={classes.span}>
                    {formReducer && formReducer.mail && formReducer.mail.data}
                  </span>
                </p>
              )}
              {formReducer?.contactDevisPro?.data && (
                <p style={{ marginTop: 16 }}>
                  Pour rappel, votre devis d’assurance multi-risque
                  professionnelle sera établi après prise de contact par les
                  équipes d’EDLC.
                </p>
              )}
            </p>
          </Grid>
          <Grid container justify="center">
            <div className={classes.separator}></div>
          </Grid>
          <Grid container justify="center" style={{ marginBottom: 48 }}>
            <span className={classes.validation}>
              Découvrez nos formations webinaires
            </span>
          </Grid>
          <Grid container justify="center" style={{ width: 700 }}>
            {webinaires.map((webinaire, index) => (
              <CardWebinaire key={index} webinaire={webinaire} />
            ))}
          </Grid>
          <Grid container item xs={12} sm={12} justify="center">
            <Link
              href="https://www.entrepreneursdelacite.org/nos-solutions-et-services"
              style={{ color: "#FFFFFF", textDecoration: "none" }}
            >
              <Button className={classes.back} variant="contained">
                Retour au site
              </Button>
            </Link>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

SendMail.propTypes = {
  history: PropTypes.object
};
